import React, { useEffect } from "react";
import { useStore } from "../../app/stores/store";
import { UserRole } from "../../app/common/enums/userRole";
import CreateUserForm from "../users/CreateUserForm";
import Dashboard from "./Dashboard";

export default function HomePage() {
  const userRole = useStore((s) => s.userStore.userRole);
  const loadMembers = useStore((s) => s.memberStore.loadMembers);

  useEffect(() => {
    if (userRole === UserRole.ADMIN) {
      loadMembers({ orderBy: "lastName" } as any);
    }
  }, [userRole, loadMembers]);

  return userRole === UserRole.ADMIN ? <Dashboard /> : <CreateUserForm />;
}
